import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import { Tabs } from "antd";
import Launchpool from "./Launchpool";
import PoSStaking from "./PoSStaking";

export default observer(() => {
  const t = useTranslation();
  const { app, finance } = useStore();

  const [tabKey, setTabKey] = useState("all");
  const onChangeTab = useCallback((key) => setTabKey(key), []);

  const tabsStyle = useMemo(() => {
    if (!app.isH5) return { margin: "40px 0 0 0" };
    return {};
  }, [app.isH5]);

  return (
    <div className={styles.main}>
      <Tabs
        size={app.isH5 ? "large" : "middle"}
        style={tabsStyle}
        defaultActiveKey={tabKey}
        onChange={onChangeTab}
        items={[
          {
            label: t("cmpt.all"),
            key: "all",
          },
          {
            label: t("finance.Launchpool"),
            key: "Launchpool",
          },
          {
            label: t("finance.PoSStaking"),
            key: "PoSStaking",
          },
        ]}
      />

      {/^(all|Launchpool)$/.test(tabKey) && <Launchpool />}
      {/^(all|PoSStaking)$/.test(tabKey) && <PoSStaking />}
    </div>
  );
});
